import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { AIScribeLinkedUserModel } from "../Models/AIScribeLinkedUserModel";
import { IAIScribeContainerModel } from "../Models/IAIScribeContainerModel";
import { AIScribeHandler } from "./Handlers/AIScribeHandler";

let defaultInstance: AIScribeStore;
class AIScribeStore extends BaseStore {
    private readonly aiScribeHandler: AIScribeHandler;
    private readonly mapper: RequestMapper;

    public Model: IAIScribeContainerModel;

    constructor(linkedUser?: AIScribeLinkedUserModel) {
        super();

        this.aiScribeHandler = new AIScribeHandler();
        this.mapper = new RequestMapper();
        this.mapper.AddInstance(this.aiScribeHandler);

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => {
            this.mapper.Map(request, this);
        });

        this.Model = Immutable.fromJS({
            PatientContactId: null,
            PatientContactFacetId: null,
            EncounterId: null,
            AIScribeConsultationId: null,
            AIScribeConsultationUrl: null,
            ShowAIScribePopup: false,
            AIScribePopupBottomPos: 0,
            AIScribePopupRightPos: 0,
            ShowSubscriptionExpiredPopup: false,
            ShowAIScribeLinkPopup: false,
            AIScribeLinkedUser: linkedUser,
            ShowAIScribeWarningActiveAssistant: false,
            ShowAIScribeMarketingPopup: false,
            DisableAIScribeMarketingPopup: false,
            ShowAIScribeUnlinkPopup: false
        });
    }

    public static createSingleton(linkedUser?: AIScribeLinkedUserModel): AIScribeStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new AIScribeStore(linkedUser));
    }
}

export { AIScribeStore, defaultInstance as aIScribeStore };
